import React from 'react';

import { SelectCountryContainer } from './styles';

export default function SelectCountry({
  label,
  allCountriesWithCustomLabel,
  selected,
  onSelect,
  fullWidth,
  ...props
}) {
  return (
    <>
      <SelectCountryContainer
        fullWidth={fullWidth}
        placeholder={label}
        selected={selected}
        onSelect={onSelect}
        customLabels={allCountriesWithCustomLabel}
        {...props}
      />
    </>
  );
}
